export { setCookie, getCookie, removeCookie } from './cookie';
export { UA } from './ua';
export { loadScript, loadScriptList, loadStyle, loadStyleList, loadImage, loadImageList, } from './loader';
export { debounce, throttle, compareVersion, padStart } from './function';
export { parseDate, formatDate, parseRemainTime, countDown } from './time-date';
export { parseQueryParam, stringifyQueryParam, getQueryParam, getQueryParams, setQueryParam, removeQueryParam, splitUrl, } from './url-query';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/fast-utils/dist/index.js
// module id = null
// module chunks = 